import _ from "lodash";
import { Tag } from "../common/video/models/VideoFilter";
import { UserSkill } from "../user/User";

// Null判定
export function isNull(obj: any) {
    return _.isNull(obj);
}

// Undefined判定
export function isUndefined(obj: any) {
    return _.isUndefined(obj);
}

// Null/Undefined判定
export function isNullorUndefined(obj: any) {
    return _.isNil(obj);
}

// 空オブジェクト判定
export function isEmpty(obj: any) {
    return _.isEmpty(obj) && obj !== 0 && typeof obj !== "boolean";
}

// String判定
export function isString(obj: any) {
    return _.isString(obj);
}

// Number判定
export function isNumber(obj: any) {
    return _.isNumber(obj);
}

// ObjectをArrayに変換する
export function toArray(obj: any) {
    return _.toArray(obj);
}

// オブジェクトをクローンする
export function clone(obj: any, customizer?: any) {
    return _.cloneDeepWith(obj, customizer);
}

// 文字列前後の空白と指定内容を削除する
export function trim(str: string | undefined, chars?: string) {
    return _.trim(str, chars);
}

// 配列の重複を除外する
export function uniq(arr: Array<any> | null | undefined) {
    return _.uniq(arr);
}

// オブジェクトから対象項目を抽出する
export function pick(obj: Object | null | undefined, targets: string | string[]) {
    return _.pick(obj, targets);
}

// オブジェクトからValueを抽出する
export function values(obj: any) {
    return _.values(obj);
}

// 配列の比較
export function isArrayEuqual(
    arr1: Array<any> | null | undefined,
    arr2: Array<any> | null | undefined
) {
    return _.isEqual(_.uniq(_.sortBy(arr1)), _.uniq(_.sortBy(arr2)));
}

// ファイルの拡張子からファイルタイプを判断する
export function CheckFileType(fileType: string, fileName: string) {
    if (
        fileType.includes("csv") ||
        (fileType.includes("excel") &&
            fileName.split(".")[fileName.split(".").length - 1] === "csv")
    ) {
        return "csv";
    } else if (fileType.includes("msword") || fileType.includes("wordprocessingml")) {
        return "docx";
    } else if (fileType.includes("pdf")) {
        return "pdf";
    } else if (fileType.includes("powerpoint") || fileType.includes("presentationml")) {
        return "ppt";
    } else if (fileType.includes("plain")) {
        return "txt";
    } else if (fileType.includes("excel") || fileType.includes("spreadsheetml")) {
        return "xls";
    } else if (fileType.includes("zip")) {
        return "zip";
    } else {
        return "file";
    }
}

// ファイル名の拡張子を抜いたファイル名を返す
export function ExtractFileName(fileName: string) {
    const index = fileName.lastIndexOf(".");
    if (index > 0) {
        return fileName.substring(0, fileName.lastIndexOf("."));
    } else {
        return fileName;
    }
}

// 「.」を含めたファイルの拡張子を返す
export function ExtractExtention(fileName: string) {
    const index = fileName.lastIndexOf(".");
    if (index > 0) {
        return fileName.substring(fileName.lastIndexOf("."));
    } else {
        return fileName;
    }
}

//タグ配列から文字列に変換
export function makeTagStr(videoTags: string[]) {
    let tagList = "";
    for (let index = 0; index < videoTags.length; index++) {
        tagList = tagList.concat(videoTags[index]);
        if (index < videoTags.length - 1) tagList += ", ";
    }
    return tagList;
}

//ミリ秒からhh:mm:ssに変換
export function milliSecondToHr(milliSecond: number) {
    let result = "00:00:00";
    if (milliSecond > 0) {
        result =
            (Math.floor(milliSecond / (1000 * 60 * 60)) < 10
                ? `0${Math.floor(milliSecond / (1000 * 60 * 60))}`
                : Math.floor(milliSecond / (1000 * 60 * 60))) +
            ":" +
            (Math.floor(milliSecond / (1000 * 60)) % 60 < 10
                ? `0${Math.floor(milliSecond / (1000 * 60)) % 60}`
                : Math.floor(milliSecond / (1000 * 60)) % 60) +
            ":" +
            (Math.floor(milliSecond / 1000) % 60 < 10
                ? `0${Math.floor(milliSecond / 1000) % 60}`
                : Math.floor(milliSecond / 1000) % 60);
    }
    return result;
}

// Tag名からidに変換する。
export const GetTagIdFromTagName = (tagNameList: string[], tags: Tag[]) => {
    const idList: number[] = [];
    tagNameList &&
        tagNameList.forEach((name) => {
            const current = tags.find((item) => item.tag.title === name);
            if (current) {
                idList.push(current.tag.id);
            }
        });
    return idList;
};

/**
 * 動画キャプション翻訳対象言語のstringリスト生成
 */
export const processLanguage = (
    languageJa: boolean,
    languageEn: boolean,
    languageZh: boolean,
    languageVi: boolean
) => {
    console.log(languageJa, languageEn, languageZh, languageVi);
    const languages = [];
    if (languageJa) {
        languages.push("ja");
    }
    if (languageEn) {
        languages.push("en");
    }
    if (languageZh) {
        languages.push("zh-Hans");
    }
    if (languageVi) {
        languages.push("vi");
    }
    return languages.join(",");
};

// スキル名からスキルIDを検索する
export const FindSkillIdBySkillName = (skillName: string, skillList: UserSkill[]) => {
    const skill = skillList.find((row) => row.skill === skillName);
    return skill?.id;
};

// スキルリストからスキルIDの配列に変換する
export const GetSkillIdsFromSkillList = (skillList: UserSkill[]) => {
    const skillIds = skillList.map((item) => item.id);
    return skillIds;
};
